import { NgModule } from '@angular/core';
import { LibContactIconComponent } from './lib-contact-icon.component';

@NgModule({
  declarations: [LibContactIconComponent],
  exports: [LibContactIconComponent],
})
export class LibContactIconModule {}
